define('views/blocks/AppInstallView',['underscore', 'backbone','app','SubView','WidgetCollectionView','moment','js-cookie','modernizr'], function (
    _, Backbone,app,SubView,WidgetCollectionView,moment,Cookies) {


    var cookieKey = 'app-install-close',
        AppInstallModel = Backbone.Model.extend({
        default:{
            closed:false
        },
        initialize:function(){
            var closed = Cookies.get(cookieKey);
            if(closed){
                this.set('closed',closed);
            }
        },
        save:function(){
            Cookies.set(cookieKey,new Date(),{expires:getCookieExpires()});
        }
    }), appInstallModel = new AppInstallModel();

    function getCookieExpires(){
        return parseInt(app.get('_APP_INSTALL_COOKIE_DAY_EXPIRES_','30')) || 30;
    }

    function requireOpenning(){
        var inapp = Modernizr.inapp,
            closed = appInstallModel.get('closed'),
            target = app.getWidgetGroup(getTarget()),
            enabled = !!target && !!parseInt(app.c('_APP_INSTALL_ENABLED_',0)),
            hasRestriction = false,
            href = window.location.href+'',
            restrictionUrlPatterns = app.c('_APP_INSTALL_URL_RESTRICTIONS_','').split("\n");
       _(restrictionUrlPatterns).each(function(pattern){
            var p = pattern.trim();
            if(!hasRestriction && p!==''){
                var basicTest = href.indexOf(p)>=0,
                    e = /^\/?(.*)(\/([iugmys]*))$/g.exec(p),
                    basePattern = !!e ? e[1] : p,
                    flags = !!e ? e[3] || '' : '',
                    regTest = false, regExp;
                try{
                    regExp = new RegExp(basePattern,flags);
                    regTest = regExp.test(href);
                }catch (e) {
                }
                hasRestriction = regTest || basicTest;
            }
       });
       if(closed){
           var closedDate = moment(new Date(closed));
           closed = moment.max(closedDate,moment().subtract(getCookieExpires(),'d')).isSame(closedDate);
       }
       return !inapp && enabled && !closed && !hasRestriction;
    }

    function getTarget(){
        var target = 'app_install_';
        if(app.isMobile()){
            if(Modernizr.iphone){
                target += 'ios';
            }else if(Modernizr.android) {
                target += 'android';
            }else{
                target = false;
            }
        }else{
            target = false;
        }
        return target;
    }


    var AppInstallView = Backbone.View.extend(SubView).extend({
        events: {
            'click .btn-close,.cta-close':'close'
        },
        initialize: function () {
            var view = this;
            view.subviews = [];
            view.render();
        },
        render:function(){
            var view = this, target = getTarget();
            if(!target){
                // si le widget n'existe pas pour le device cible
                view.close();
                return;
            }
            var widgetCollection = new WidgetCollectionView(target);
            widgetCollection.render();
            view.$el
                .addClass('app-install')
                .append(widgetCollection.$el);
            view.attachView(widgetCollection);
            view.delegateEvents();

        },
        close:function(){
            appInstallModel.save();
            this.trigger('close',this);
        }
    });

    AppInstallView.requireOpenning = requireOpenning;

    return AppInstallView;
});
